export const cargoTypeNeedsTemperature = (cargoType) => {
    return ["COOL", "FREEZE", "PHARMA"].includes(cargoType);
};
//# sourceMappingURL=cargo-type-needs-temperature.js.map